/**
 * Managing state without using Vuex
 */
import Vue from 'vue';

const state = {
    imagePath           : '',
    loading             : false,
    showList            : false,
    appRegion           : 'us',
    canBookOnline       : true,
    showFittingLocations: true,
    searchType          : 'fittinglocation',
    countryCode         : 'US',
    searchPostalCode    : '',
    searchDistance      : '25',
    distance            : 12,
    distancePref        : 'mi',
    awayText            : 'away',
    defaultlocation     : false,
    updateAsMoving      : false,
    disableSearchButton : true,
    geoCache            : {},
    stores              : [],
    map                 : false,
    loadMap             : false,
    mapCenter           : {
        default: {
            lat: 37.09024, // 54.0233621
            lng: -100.712891 // -4.6198264
        }
    },
    api: false,

    getMapCenter () {
        return this.mapCenter[this.appRegion] ? this.mapCenter[this.appRegion] : this.mapCenter.default;
    },

    setCountry: (country) => {
        this.appRegion = country;
        this.countryCode = country;
        this.distancePref = 'mi';
    }
};

export default Vue.observable(state);
